export default __webpack_public_path__ + "static/media/moon_drop.b4abe8f0.mp3";